import { ReactComponent as NotFound } from '../../assets/images/svg/404.svg';
import { ReactComponent as BGLeft } from '../../assets/images/svg/left-side-background.svg';
import { ReactComponent as BGRight } from '../../assets/images/svg/right-side-background.svg';
import { LinkExpiredContainer } from './style';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

const LinkExpired = () => {
  const { formatMessage } = useIntl();
  const location = useLocation();
  const errorMessage = (location.state as { message?: string })?.message;

  return (
    <LinkExpiredContainer>
      <div className="img-container">
        <BGRight />
        <NotFound />
        <BGLeft />
      </div>
      <label>{formatMessage({ id: 'title422' })}</label>
      <span>{errorMessage || formatMessage({ id: 'desc422' })}</span>
    </LinkExpiredContainer>
  );
};

export default LinkExpired;

